<!-- Search + Tree: flex column so tree-container can scroll -->
<div
  data-testid="business-unit-tree-container"
  class="mr-4 flex flex-col min-h-0 flex-1 overflow-hidden"
>
  <div class="search-section flex-shrink-0">
    <app-search-form
      data-testid="business-unit-tree-search-form"
      [searchFormat]="searchConfig"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    >
      <div slot="actions" class="flex gap-2 items-center">
        <app-button
          [testId]="'business-unit-tree-sync-btn'"
          icon="sync"
          type="primary"
          [outlined]="true"
          [loading]="syncing()"
          [attr.aria-label]="
            'configuration.business_unit.sidebar.sync_departments' | translate
          "
          (emitOnClick)="onSyncDepartments()"
        ></app-button>
        <app-button
          [testId]="'business-unit-tree-assign-store-btn'"
          [label]="
            'configuration.business_unit.sidebar.assign_store' | translate
          "
          type="info"
          (emitOnClick)="onAssignStore()"
        ></app-button>
      </div>
    </app-search-form>
  </div>

  <!-- Tree Container -->
  <div class="tree-container">
    @if (isLoading()) {
      <div class="loading-container">
        <div data-testid="business-unit-tree-loading" class="custom-spinner"></div>
        <span class="loading-text">{{
          "configuration.business_unit.sidebar.loading_business_units"
            | translate
        }}</span>
      </div>
    } @else {
      <p-tree
        data-testid="business-unit-tree"
        [value]="filteredTreeData()"
        [selectionMode]="'single'"
        [selection]="selectedNode()"
        (onNodeSelect)="onNodeSelect($event.node)"
        (onNodeExpand)="onNodeExpand($event.node)"
        (onNodeCollapse)="onNodeCollapse($event.node)"
        class="category-tree"
      >
        <ng-template pTemplate="default" let-node>
          <div class="tree-node-content" [attr.data-type]="node.data?.type">
            <div class="tree-node-title-row">
              <span class="node-label" [title]="node.label">
                {{ node.label }}
              </span>
              @if (canUpdate && isChannelNode(node)) {
                <button
                  [attr.data-testid]="
                    'business-unit-tree-unlink-channel-btn-' + node.data?.id
                  "
                  type="button"
                  class="tree-unlink-btn"
                  [attr.aria-label]="
                    'configuration.business_unit.sidebar.unlink_channel'
                      | translate
                  "
                  (click)="onUnlinkChannel(node, $event)"
                >
                  <i class="pi pi-trash"></i>
                </button>
              }
            </div>
          </div>
        </ng-template>
      </p-tree>
    }
  </div>
</div>
